// eslint-disable-next-line unicorn/prevent-abbreviations
export default class KformDevToolbarController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 */
	constructor($copyToClipboard) {
		this.$copyToClipboard = $copyToClipboard;
		this.disabled = false;
		/** @type {import('~/scripts/services/model/form').default | undefined} */
		this.form = undefined;
		this.parent = undefined;
	}

	copyKid() {
		this.$copyToClipboard(this.form?.kid, true);
	}
}
